import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { DocumentVersion, DocumentVersionCreate, DocumentVersionFilter } from '../data/documentVersion';

export function createDocumentVersionService(client: AxiosInstance) {
  return createCrudService<DocumentVersion, DocumentVersionCreate, DocumentVersionFilter>(
    client,
    '/document-management/DocumentVersion',
    'id',
  );
}

export type DocumentVersionService = CrudService<DocumentVersion, DocumentVersionCreate, DocumentVersionFilter>;
